import * as Yup from 'yup';

export const INDUSTRY_OPTIONS = [
  'Aerospace',
  'Agriculture',
  'Automotive',
  'Computers and Electronics',
  'Consumer Goods',
  'Education',
  'Energy - Oil and Gas',
  'Energy - Power and Utilities',
  'Financial Services',
  'Gaming',
  'Government',
  'Healthcare',
  'Hospitality',
  'Life Sciences',
  'Manufacturing',
  'Marketing and Advertising',
  'Media and Entertainment',
  'Mining',
  'Non-Profit Organization',
  'Other',
  'Professional Services',
  'Real Estate and Construction',
  'Retail',
  'Software and Internet',
  'Telecommunications',
  'Transportation and Logistics',
  'Travel',
  'Wholesale and Distribution',
];

export const PRIORITIZED_COUNTRIES = [
  { code: "AU", name: "Australia" },
  { code: "NZ", name: "New Zealand" },
  { code: "US", name: "United States" },
  { code: "CA", name: "Canada" },
  { code: "GB", name: "United Kingdom" },
  { code: "IN", name: "India" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "QA", name: "Qatar" },
  { code: "KW", name: "Kuwait" },
];

export const VALIDATION_SCHEMA = Yup.object({
  companyName: Yup.string().required('Company name is required'),
  industryVertical: Yup.string().required('Industry vertical is required'),
  websiteURL: Yup.string().required('Website URL is required'),
  countryCode: Yup.string().required('Country is required'),
  postalCode: Yup.string().required('Postal code is required'),
  workloadName: Yup.string().required("Project Title is required"),
  customerAddress: Yup.string(),
  customerCity: Yup.string(),
  customerState: Yup.string(),
  customerEmail: Yup.string().email('Must be a valid email'),
  partnerEmail: Yup.string().email('Must be a valid email'),
  customerMobile: Yup.string()
  .nullable()
  .optional()
  .matches(
    /^\+[1-9]\d{1,14}$/,
    'Must be a valid international mobile number with country code',
  ),
  partnerMobile: Yup.string()
  .nullable()
  .optional()
  .matches(
    /^\+[1-9]\d{1,14}$/,
    'Must be a valid international mobile number with country code',
  ),
  partnerTitle: Yup.string(),
  projectType: Yup.string().required("Project Type is required."),
  partnerMarketingActivity: Yup.bool(),
  partnerCampaignCode: Yup.string(),
  partnerFundingUsed: Yup.bool(),
  expectedCustomerSpend: Yup.number()
  .typeError('Must be a number')
  .positive('Must be a positive number'),
  estimatedIncrementalMRR: Yup.number(),
  estimatedEligibleCredit: Yup.number(),
  incrementalMRR: Yup.number()
  .typeError('Must be a number')
  .positive('Must be a positive number'),
});

export const INITIAL_VALUES = {
  companyName: '',
  industryVertical: '',
  websiteURL: '',
  workloadName: '',
  countryCode: '',
  postalCode: '',
  customerAddress: '',
  customerCity: '',
  customerState: '',
  customerFirstName: '',
  customerLastName: '',
  customerTitle: '',
  customerEmail: '',
  customerMobile: '',
  partnerFirstName: '',
  partnerLastName: '',
  partnerTitle: 'PartnerAccountManager',
  partnerEmail: '',
  partnerMobile: '',
  projectType: '',
  partnerMarketingActivity: false,
  partnerCampaignCode: '',
  partnerFundingUsed: false,
  nationalSecurity: false,
  expectedCustomerSpend: 500,
  estimatedIncrementalMRR: 378,
  estimatedEligibleCredit: 453,
  incrementalMRR: 500,
}
